














































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class ComfortTempSlider extends Vue {
  @Prop({ type: Array, default: () => [20, 22, 26, 28] }) value!: number[]
  
  localValues: number[] = [20, 22, 26, 28]
  draggingIndex: number = -1
  min: number = 10
  max: number = 40
  
  mounted() {
    if (this.value && this.value.length === 4) {
      this.localValues = [...this.value]
    }
  }
  
  @Watch('value', { deep: true })
  onValueChange(val: number[]) {
    if (val && val.length === 4 && this.draggingIndex === -1) {
      this.localValues = [...val]
    }
  }
  
  getThumbPosition(value: number): number {
    return ((value - this.min) / (this.max - this.min)) * 100
  }
  
  getZoneWidth(zoneIndex: number): number {
    if (zoneIndex === 0) {
      return this.getThumbPosition(this.localValues[0])
    } else if (zoneIndex === 4) {
      return 100 - this.getThumbPosition(this.localValues[3])
    } else {
      return this.getThumbPosition(this.localValues[zoneIndex]) - this.getThumbPosition(this.localValues[zoneIndex - 1])
    }
  }
  
  handleMouseDown(event: MouseEvent, index: number) {
    event.preventDefault()
    this.draggingIndex = index
    
    const handleMove = (e: MouseEvent) => {
      e.preventDefault()
      this.updateValue(e.clientX)
    }
    
    const handleUp = () => {
      this.draggingIndex = -1
      document.removeEventListener('mousemove', handleMove)
      document.removeEventListener('mouseup', handleUp)
    }
    
    document.addEventListener('mousemove', handleMove)
    document.addEventListener('mouseup', handleUp)
  }
  
  handleTouchStart(event: TouchEvent, index: number) {
    event.preventDefault()
    this.draggingIndex = index
    
    const handleMove = (e: TouchEvent) => {
      e.preventDefault()
      this.updateValue(e.touches[0].clientX)
    }
    
    const handleEnd = () => {
      this.draggingIndex = -1
      document.removeEventListener('touchmove', handleMove)
      document.removeEventListener('touchend', handleEnd)
    }
    
    document.addEventListener('touchmove', handleMove, { passive: false })
    document.addEventListener('touchend', handleEnd)
  }
  
  updateValue(clientX: number) {
    const container = this.$refs.sliderContainer as HTMLElement
    if (!container || this.draggingIndex === -1) return
    
    const rect = container.getBoundingClientRect()
    const offsetX = clientX - rect.left
    const percentage = Math.max(0, Math.min(1, offsetX / rect.width))
    let newValue = Math.round(this.min + percentage * (this.max - this.min))
    
    // 限制滑块顺序
    if (this.draggingIndex > 0) {
      newValue = Math.max(newValue, this.localValues[this.draggingIndex - 1] + 1)
    }
    if (this.draggingIndex < 3) {
      newValue = Math.min(newValue, this.localValues[this.draggingIndex + 1] - 1)
    }
    
    newValue = Math.max(this.min, Math.min(this.max, newValue))
    
    if (this.localValues[this.draggingIndex] === newValue) return
    
    const newValues = [...this.localValues]
    newValues[this.draggingIndex] = newValue
    this.localValues = newValues
    this.$emit('input', newValues)
    this.$emit('change', newValues)
  }
}
